// Interfaces
import { ILayoutAccountProps } from './interfaces'

const LayoutAccount = ({ children }: ILayoutAccountProps) => {
  return (
    <div className={'h-screen'}>
      <div className={'flex items-center justify-center text-center h-full'}>{children}</div>
    </div>
  )
}

export { LayoutAccount }
